(function () {
    if (
      !window.HOLIDAY_UPSELL ||
      !window.HOLIDAY_UPSELL.enabled ||
      (!window.HOLIDAY_UPSELL.option1Variant &&
      !window.HOLIDAY_UPSELL.option2Variant)
    ) {
      return;
    }


  let pendingCheckoutClick = null;


  /* ==============================
     Helpers
  ============================== */

  function cartHasHolidayUpsell() {
    return fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
      return cart.items.some(item =>
        item.variant_id === window.HOLIDAY_UPSELL.option1Variant ||
        item.variant_id === window.HOLIDAY_UPSELL.option2Variant
      );

      })
      .catch(() => false); // fail-safe: never block checkout
  }

  /* ==============================
     Modal Control
  ============================== */

  function openUpsell(originalCheckoutButton) {
    pendingCheckoutClick = originalCheckoutButton;
    sessionStorage.setItem("holidayUpsellShown", "true");

    const modal = document.getElementById("yvr-holiday-upsell");
    if (!modal) return;

    modal.style.display = "flex";
    modal.classList.add("is-mounted");

    requestAnimationFrame(() => {
      modal.classList.add("is-open");
    });
  }

  function closeUpsell() {
    const modal = document.getElementById("yvr-holiday-upsell");
    if (!modal) return;

    modal.classList.remove("is-open");

    setTimeout(() => {
      modal.classList.remove("is-mounted");
      modal.style.display = "none";
    }, 300);
  }

  function resumeCheckout() {
    closeUpsell();
    if (pendingCheckoutClick) {
      pendingCheckoutClick.click();
    }
  }

  function addVariantAndCheckout(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
      }),
    })
      .then(() => resumeCheckout())
      .catch(() => resumeCheckout());
  }

  /* ==============================
     Modal Buttons
  ============================== */

  document.addEventListener("DOMContentLoaded", function () {
    const addBtn = document.getElementById("yvr-holiday-upsell-add");
    const skipBtn = document.getElementById("yvr-holiday-upsell-skip");
    const select = document.getElementById("yvr-holiday-upsell-select");

    if (!addBtn || !skipBtn || !select) return;

    addBtn.addEventListener("click", function () {
      const value = select.value;

      if (!value) {
        select.classList.add("shake");
        select.addEventListener(
          "animationend",
          () => select.classList.remove("shake"),
          { once: true }
        );
        return;
      }

    if (value === "option1") {
      addVariantAndCheckout(window.HOLIDAY_UPSELL.option1Variant);
    }

    if (value === "option2") {
      addVariantAndCheckout(window.HOLIDAY_UPSELL.option2Variant);
    }

    });

    skipBtn.addEventListener("click", resumeCheckout);
  });

  /* ==============================
     INTERCEPT CHECKOUT
  ============================== */

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("form.cart [type='submit']");
    if (!btn) return;

    // Already shown this session → do nothing
    if (sessionStorage.getItem("holidayUpsellShown")) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    cartHasHolidayUpsell().then(alreadyInCart => {
      if (alreadyInCart) {
        // Mark as shown so we don’t re-intercept
        sessionStorage.setItem("holidayUpsellShown", "true");
        btn.click();
        return;
      }

      openUpsell(btn);
    });
  });
})();
